/* eslint-disable react-perf/jsx-no-new-object-as-prop */
import { useRouter } from 'next/router'
import React, { useCallback, useEffect, useState } from 'react'

import { HistoryContext } from './utils'

function HistoryProvider({ children }) {
  const { asPath } = useRouter()
  const [history, setHistory] = useState<string[]>([])
  useEffect(() => {
    setHistory((prevHistory) => [...prevHistory, asPath])
  }, [asPath])

  const getLastMatchingPath = useCallback(
    (regex: RegExp) => {
      const reversedHistory = [...history].reverse()
      const match = reversedHistory.find((path) => regex.test(path))
      return match || null
    },
    [history]
  )

  /** */
  return <HistoryContext.Provider value={{ history, getLastMatchingPath }}>{children}</HistoryContext.Provider>
}

export default HistoryProvider
